(function ($, app) {
    if (!$ || !$.fn.DataTable) {
        return;
    }

    const tables = {};

    function filtersFor($table) {
        const selector = `form[data-table="#${$table.attr('id')}"]`;
        return app.helpers.serializeForm($(selector));
    }

    app.datatable = {
        init() {
            $('.js-data-table').each(function () {
                const $table = $(this);
                const columns = window.ITConnectTables?.[$table.attr('id')] || [];

                tables[$table.attr('id')] = $table.DataTable({
                    processing: true,
                    serverSide: true,
                    responsive: true,
                    searching: false,
                    lengthChange: false,
                    order: [],
                    ajax: {
                        url: $table.data('url'),
                        data(data) {
                            return Object.assign(data, filtersFor($table));
                        },
                    },
                    columns,
                    drawCallback() {
                        app.helpers.refreshIcons();
                    },
                });
            });
        },

        reload(selector) {
            const id = selector ? selector.replace('#', '') : $('.js-data-table').first().attr('id');

            if (tables[id]) {
                tables[id].ajax.reload(null, false);
            }
        },

        adjust() {
            Object.keys(tables).forEach((id) => {
                tables[id].columns.adjust();

                if (tables[id].responsive) {
                    tables[id].responsive.recalc();
                }
            });
        },
    };

    let resizeTimer = null;

    $(window).on('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => app.datatable.adjust(), 160);
    });

    $(document).on('submit', '.js-table-filters', function (event) {
        event.preventDefault();
        app.datatable.reload($(this).data('table'));
    });

    $(document).on('click', '.js-reset-filters', function () {
        const $form = $(this).closest('form');
        $form[0].reset();
        $form.find('select').val('').trigger('change');
        $form.find('[name="date_from"], [name="date_to"]').val('');
        app.datatable.reload($form.data('table'));
    });
})(window.jQuery, window.ITConnect);
